/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const CardAdd: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M19 13C19.5523 13 20 13.4477 20 14V16H22L22.1025 16.0049C22.6067 16.0562 23 16.4823 23 17C23 17.5177 22.6067 17.9438 22.1025 17.9951L22 18H20V20C20 20.5523 19.5523 21 19 21C18.4477 21 18 20.5523 18 20V18H16C15.4477 18 15 17.5523 15 17C15 16.4477 15.4477 16 16 16H18V14C18 13.4477 18.4477 13 19 13ZM19.5 4C21.1569 4 22.5 5.34315 22.5 7V10C22.5 10.5523 22.0523 11 21.5 11C20.9477 11 20.5 10.5523 20.5 10V7C20.5 6.44772 20.0523 6 19.5 6H4.5C3.94772 6 3.5 6.44772 3.5 7V17C3.5 17.5523 3.94772 18 4.5 18H12C12.5523 18 13 18.4477 13 19C13 19.5523 12.5523 20 12 20H4.5C2.84315 20 1.5 18.6569 1.5 17V7C1.5 5.34315 2.84315 4 4.5 4H19.5ZM10.25 9C10.3881 9 10.5 9.11193 10.5 9.25V11.25C10.5 11.3881 10.3881 11.5 10.25 11.5H7.25C7.11193 11.5 7 11.3881 7 11.25V9.25C7 9.11193 7.11193 9 7.25 9H10.25Z'
      fill='currentColor'
    />
  </React.Fragment>
)
